<template>
  <app-warp title='经销商后台' color='#efefef' padding='true'>
    <template #app-content>
      <div class="navListBox width100">
        <div class="height-177 s_flex_ali headBgImg s_po_re" style='background:linear-gradient(90deg, #1C202B 0%, #1C202B 100%);' @click='modularType = "img"' v-show="activeKey==1">
          <div class="s_flex_bian_c p-tb0-lr15 width100">
            <div class="s_flex_ali">
              <img class="width-70 height-70" style="border:2xp solid #fff" src="@/assets/images/user.png" alt="">
              <div class="m-l-15 ">
                <p class="fz-18 s_font_b s_cfff">销售经理 张三</p>
                <p class="s_c9d m-t-10 fz-13 ">管辖区域：华南区、华东区···</p>
              </div>
            </div>
            <RightOutlined class="s_cfff" />
          </div>
          <div class="positionBox s_shou" :class='modularType == "img"?"borderRed2":""'></div>
        </div>
        <div class="s_po_re p-t-10   s_bor10 s_over_h " style="top:-40px;left:50%;transform: translateX(-50%);" v-show='activeKey == 1 || !reportForm' @click='modularType = "nav"'>
          <div>
            <div class="width95 " style="margin:0 auto;box-shadow: 2px 2px 20px 5px rgba(208, 208, 208, 0.2);">
              <div class="s_bf m-b-10 s_bor10">
                <div class="s_flex_wrap s_flex_center p-15">
                  <div class="  s_flex_center s_flex_fdc flex_1">
                    <div class="s_flex_ali">
                      <cIcon type="mdsl" size="14" class="m-r-5" /> <span class="s_font_b fz-20">200</span>
                    </div>
                    <p class="s_c333 text-ac fz-13">门店数量</p>
                  </div>
                  <div class="  s_flex_center s_flex_fdc flex_1">
                    <div class="s_flex_ali">
                      <cIcon type="jxssl" size="14" class="m-r-5" /> <span class="s_font_b fz-20">114</span>
                    </div>
                    <p class="s_c333 text-ac fz-13">经销商数量</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="commonlyList.length">
              <div class="s_bf m-b-10">
                <p class="m-b-15 fz-15 p-t-15 m-l-15 s_c333 s_font_b">常用功能</p>
                <div class="s_flex_wrap  s_flex_ali ">
                  <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-for='item in commonlyList' :key='item' :span="8">
                    <cIcon :type="item.icon" size="28" class="m-r-5" />
                    <p class="s_c333 text-ac fz-13">{{item.menu_name}}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-for='item in homeList' :key='item'>
            <div class="s_bf m-b-10">
              <p class="m-b-15 fz-15 p-t-15 m-l-15 s_c333 s_font_b">{{item.name}}</p>
              <div class="s_flex_wrap  " :class="item.type==1?'s_flex_center':'s_flex_ali'">
                <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-for='items in item.list' :key='items' :span="8">
                  <cIcon :type="items.icon" size="28" class="m-r-5" />
                  <p class="s_c333 text-ac fz-13">{{items.name}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="s_po_re p-t-10" v-show='activeKey == 2' @click='modularType = "nav"'>
          <div v-for='item in reportFormList' :key='item'>
            <div class="s_bf m-b-10" v-if="item.list.filter(v=>v.checked).length>0">
              <p class="m-b-15 fz-15 p-t-15 m-l-15 s_c333">{{item.name}}</p>
              <div class="s_flex_wrap  s_flex_ali">
                <div class="m-b-20 width25 s_flex_center s_flex_fdc" v-for='items in item.list' :key='items' :span="8" v-show='items.checked'>
                  <cIcon :type="items.icon" size="28" class="m-r-5" />
                  <p class="s_c333 text-ac fz-13">{{items.name}}</p>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="positionBox s_shou" :class='modularType == "nav"?"borderRed2":""'></div> -->
        </div>
      </div>
      <div class="height-50 s_bf width100 s_flex_bian_c s_bor_t_cd9 s_po_ab_bl">
        <p class="height-45 s_flex_center  s_flex_fdc" :class='[activeKey == 1 || !reportForm ? "s_c376":"",reportForm ? "width50":"width100"]'>
          <cIcon type="home_11" size="17" class="m-r-5" />首页
        </p>
        <p class="height-45 s_flex_center s_flex_fdc s_bor_l_cd9" v-if='reportForm' :class='[activeKey == 2 ? "s_c376":"",reportForm ? "width50":"width100"]'>
          <cIcon type="home_20" size="17" class="m-r-5" />数据
        </p>
        <p class="height-45 s_flex_center s_flex_fdc s_bor_l_cd9" v-if='reportForm' :class='[activeKey == 2 ? "s_c376":"",reportForm ? "width50":"width100"]'>
          <cIcon type="home_30" size="17" class="m-r-5" />我的
        </p>
      </div>
    </template>
    <template #app-sider>
      <div class="p-24">
        <p class="fz-18 s_font_b s_c333">首页菜单</p>
        <a-divider />
        <p class="m-b-20">设置品牌业务员的常用功能入口，最多设置8个</p>
        <a-tabs type="card" v-model:activeKey="activeKey">

          <a-tab-pane :key="1" tab="首页">
            <a-button class="width-100 m-b-24" type="primary" @click="visible=true">添加</a-button>
            <a-table :pagination='false' bordered :columns='columns' :data-source='commonlyList' class="tableFixBox">
              <template v-slot:action="{ record,index }">
                <a-button type="link" @click='delModule(record,index)'>删除</a-button>
              </template>
              <template v-slot:sort="{ record }">
                <a-input-number v-model:value="record.sort" style="width:100px"></a-input-number>
              </template>
            </a-table>
          </a-tab-pane>
          <!-- <a-tab-pane :key="2" tab="数据">
            <div class="" v-for='item in reportFormList' :key='item'>
              <p class="m-b-20 fz-15 s_font_b s_c333">{{item.name}}</p>
              <div class="s_flex_wrap  s_flex_ali">
                <div class="m-b-20 width-130 s_flex_center s_flex_fdc" v-for='items in item.list' :key='items' :span="8">
                  <span class="iconfont fz-30 " :class="'icon-'+items.icon" :style="items.color?'color:'+items.color:''"></span>
                  <p class="s_c333 text-ac fz-13">
                    <a-checkbox v-model:checked="items.checked"><span class="s_c333">{{items.name}}</span></a-checkbox>
                  </p>
                </div>
              </div>
            </div>
            <a-divider />
          </a-tab-pane> -->
        </a-tabs>
      </div>

      <a-button class="width-100 m-l-24 m-b-24" type="primary" v-has:setSalesmanApplication="setData">保存</a-button>
    </template>
  </app-warp>
  <a-modal v-model:visible="visible" :width="1000" v-if="visible" :footer="null">
    <moduleSelect :selectList="commonlyList" v-on:select="selectModule" />
  </a-modal>
</template>
<script>
import { RightOutlined } from "@ant-design/icons-vue";
import { ref, onMounted, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import { iscode } from "@/utils/app";
import store from "@/store";
import { setDealerSaleTemplate } from "@/api/dealer";
import { getBrandSaleOftenUseMenu,setBrandSaleOftenUseMenu } from "@/api/salesman";
import moduleSelect from "./moduleSelect";
import cIcon from "./c-icon";
const columns = [
  {
    title: "应用名称",
    dataIndex: "menu_name",
    key: "menu_name",
  },
  {
    title: "所属模块",
    dataIndex: "module",
    key: "module",
  },
  {
    title: "排序",
    dataIndex: "sort",
    key: "sort",
    slots: { customRender: "sort" },
  },
  {
    title: "操作",
    key: "action",
    width: 100,
    slots: { customRender: "action" },
  },
];
export default {
  components: { RightOutlined, cIcon, moduleSelect },
  setup(props) {
    const state = reactive({
      visible: false, //
      info: store.state.user.info,
      modularType: "img",
      image: "",
      bgImg: "ydd_resource/home.png",
      activeKey: 1,
      reportForm: true,
      commonlyList: [],
      homeList: [
        {
          name: "渠道服务",
          list: [
            {
              icon: "jxsgl",
              name: "经销商管理",
              url: "/pages/dealer/dealer",
              checked: true,
              color: "#317FDE",
            },
            {
              icon: "mdgl",
              name: "门店管理",
              url: "/pages/store/store",
              checked: true,
              color: "#317FDE",
            },
            {
              icon: "jxsywy",
              name: "经销商业务员",
              url: "/pages/clerk/achievement",
              checked: true,
              color: "#F1AB37",
            },
            {
              icon: "dygl",
              name: "店员管理",
              url: "/pages/storeClerk/storeClerk",
              checked: true,
              color: "#FF7A38",
            },
            {
              name: "渠道资产",
              icon: "qdzc",
              checked: true,
              url: "/pages/expense_account/giveExpenseAccount",
              color: "#f1ab37",
            },
            {
              icon: "bxjd",
              name: "报销进度",
              url: "/pages/expense_account/superiorExpenseAccount",
              checked: true,
              color: "#D94242",
            },
          ],
        },
        // {
        //   name: "营销服务",
        //   list: [
        //     {
        //       icon: "zbhb",
        //       name: "直播海报",
        //       url: "/pages/live/index",
        //       checked: true,
        //       color: "#E3AC44",
        //     },
        //     {
        //       icon: "mshb",
        //       name: "秒杀海报",
        //       url: "/pages/spike/index",
        //       checked: true,
        //       color: "#CC6117",
        //     },
        //     {
        //       icon: "pthb",
        //       name: "拼团海报",
        //       url: "/pages/groupActivity/index",
        //       checked: true,
        //       color: "#CC6117",
        //     },
        //     {
        //       icon: "zmyq",
        //       name: "招募邀请",
        //       url: "/pages/distribution_center/index",
        //       checked: true,
        //       color: "#CC6117",
        //     },
        //   ],
        // },
        {
          name: "商品溯源",
          list: [
            {
              checked: true,
              color: "#D44444",
              icon: "chsm",
              name: "出货扫码",
              url: "/pages/anti_fleeing_goods/scanCodeForGoods",
            },
            {
              checked: true,
              color: "#C93C3C",
              icon: "thgl",
              name: "商品退货",
              url: "/pages/anti_fleeing_goods/returnsManagement",
            },
            {
              checked: true,
              color: "#33A3F0",
              icon: "spzz",
              name: "商品追踪",
              url: "/pages/anti_fleeing_goods/productTracking",
            },
          ],
        },
      ],

      reportFormList: [
        {
          name: "扫码数据",
          list: [
            {
              icon: "xfzsm",
              name: "消费者扫码",
              url: "/pages/chart/scanCodeData",
              checked: true,
              color: "#d36d4c",
            },
            // {
            //   icon: "dgsm",
            //   name: "导购扫码",
            //   url: "/pages/chart/scanCodeData",
            //   checked: true,
            //   color: "#d36d4c",
            // },
          ],
        },
        {
          name: "渠道数据",
          list: [
            {
              icon: "qdkc",
              name: "渠道库存",
              url: "/pages/anti_fleeing_goods/subInventory",
              checked: true,
              color: "rgb(49, 76, 198)",
            },
            {
              icon: "chsj",
              name: "窜货数据",
              url: "/pages/fleeingGoodsData/index",
              checked: true,
              color: "rgb(49, 76, 198)",
            },
            {
              icon: "chjl",
              name: "出货记录",
              url: "/pages/anti_fleeing_goods/shipmentRecord",
              checked: true,
              color: "rgb(49, 76, 198)",
            },
            {
              icon: "jxsdx",
              name: "经销商动销",
              url: "/pages/dealer/dealerPin",
              checked: true,
              color: "rgb(49, 76, 198)",
            },
            {
              icon: "mddx",
              name: "门店动销",
              url: "/pages/store/storePin",
              checked: true,
              color: "rgb(49, 76, 198)",
            },
          ],
        },
        {
          name: "营销数据",
          list: [
            {
              icon: "jxsyj",
              name: "经销商业绩",
              url: "/pages/dealer/dealerGrades",
              checked: true,
              color: "#317fde",
            },
            {
              icon: "mdyj",
              name: "门店业绩",
              url: "/pages/store/storeGrades",
              checked: true,
              color: "#E14141",
            },
            {
              icon: "dyyj",
              name: "店员业绩",
              url: "/pages/storeClerk/storeClerkGrades",
              checked: true,
              color: "#E14141",
            },
            {
              icon: "mdkh",
              name: "门店客户",
              url: "/pages/store/customer",
              checked: true,
              color: "#E14141",
            },
            {
              icon: "zbhd",
              name: "直播活动",
              url: "/pages/live/channelData",
              checked: true,
              color: "#E14141",
            },
            {
              icon: "mshd",
              name: "秒杀活动",
              url: "/pages/spike/channelData",
              checked: true,
              color: "#E14141",
            },
            {
              icon: "pthb",
              name: "拼团活动",
              url: "/pages/groupActivity/channelData",
              checked: true,
              color: "#E14141",
            },
            {
              icon: "dbhd",
              name: "夺宝活动",
              url: "/pages/treasure/channelData",
              checked: true,
              color: "#E14141",
            },
          ],
        },
      ],
    });
    const $router = inject("$router");
    const $Modal = inject("$Modal");
    const _lodash = inject("_lodash");
    const initData = async () => {
      let result = await getBrandSaleOftenUseMenu()
        .then((res) => res.data)
        .catch((error) => error);
      state.commonlyList = result.data;
      //  state.homeList=result.data.content.homeList
      //  state.reportFormList=result.data.content.reportFormList
    };
    const setData = async () => {
      var menu_list=state.commonlyList.map(v=>  {
        return{
          menu_id:v.id,
          sort:v.sort
        }
      })
      
      let result = await setBrandSaleOftenUseMenu({menu_list})
        .then((res) => res.data)
        .catch((error) => error);
      iscode(result, true);
      initData();

    };
    onMounted(() => {
      initData();
    });
    const selectModule = (data) => {
      state.visible = false;
      state.commonlyList = data;
    };
    const delModule = (data, index) => {
      state.commonlyList.splice(index, 1);
    };
    return {
      ...toRefs(state),
      setData,
      columns,
      selectModule,
      delModule,
    };
  },
};
</script>
<style lang="less" scoped>
.headBgImg {
  background-size: cover;
}
.positionBox {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}
.positionBox:hover {
  border: 2px dashed rgba(255, 0, 0, 0.5);
  box-sizing: border-box;
}
.borderRed2 {
  border: 2px dashed rgba(255, 0, 0, 0.5);
}
.navListBox {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 45px;
  overflow-y: scroll;
}
</style>